import { CoreException, Either } from "../../../../sdk";
import { ReasonRejectedMobility } from "../../domain/rejected-reason-mobility";

export abstract class ReasonsRejectedMobilityRepository {
  abstract getReasons(): Promise<Either<CoreException, ReasonRejectedMobility[]>>;
  abstract sendReason(itemRequestId: number, reasonRejectedId: number): Promise<Either<CoreException, boolean>>;
} 